import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

export type SequentialFitPayload = {
  orderIds: string[]
  dstRoute: uui.domain.client.rm.RouteIdentifier
}

/**
 * Sequential fit orders into a route, keeping existing sequence.
 * Uses the sequentialFit RPC endpoint.
 *
 * @private
 */
export const sequentialFit = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.SequentialFitResult,
  // First argument to the payload creator
  SequentialFitPayload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/sequentialFit', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/order/sequentialFit', {
      category: 'rpc',
      type: 'rpc/order/sequentialFit',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {sequentialFit}`,
      { tags: ['rpc', 'order'], info: { payload, error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Sequential fit for orders [${payload.orderIds.join(', ')}] to route {vehicle: ${payload.dstRoute.vehicleId}, date: ${payload.dstRoute.date}} failed`,
      error,
    })
  }
})
